@for (hour of hours; track hour) {
  <div
    class="pointer-events-none relative ml-[-48px] border-t border-t-background-light-grey"
    [style.gridRowStart]="$index"
    [style.gridRowSpan]="intervalCount"
  >
    @if (showcaseScrollStartHour === hour) {
      <div #showcaseScrollHour class="absolute bottom-[20px]"></div>
    }
    @if (defaultStartHour === hour) {
      <div #defaultScrollHour class="absolute bottom-[20px]"></div>
    }
    @if (currentTimeWithTimeZone().hour === hour) {
      <div
        #timeIndicator
        class="time-indicator absolute z-[95] flex h-1.5 w-full items-center overflow-hidden"
        [class.invisible]="!isToday"
        [style.top.%]="timePassedOfHourInPercent$ | async"
      >
        <div class="relative aspect-square h-1.5 w-1.5 rounded-full bg-states-deep-red"></div>
        <div class="time-bar-inner h-0.5 w-full bg-states-deep-red"></div>
      </div>
    }
  </div>
}
